module.exports = __webpack_public_path__ + "img/green-energy.f8172fb6.svg";